import { formatValue } from 'react-currency-input-field';

const formatCurrency = (value, prefix = '$') => (
  formatValue({ value: `${value}`, groupSeparator: ",", decimalSeparator: ".", prefix })
);

export { formatCurrency };
